import classnames from "classnames";
import React, { useState } from "react";
import Swiper from "swiper";
import { useString } from "../../i18n/GetText";
import { useIsRtl } from "../../utils/LayoutContext";
import CarouselButton from "../CarouselButton/CarouselButton";
import SwiperCarousel from "../SwiperCarousel/SwiperCarousel";
import styles from "./ProjectsCarousel.module.scss";

interface ProjectsCarouselProps {
  className?: string;
  children: JSX.Element[];
}

const ProjectsCarousel = ({
  children: slides,
  className
}: ProjectsCarouselProps) => {
  const [swiper, setSwiper] = useState<Swiper>();
  const isRtl = useIsRtl();
  const previousString = useString("previous");
  const nextString = useString("next");

  return (
    <div className={classnames(styles.root, className)}>
      <CarouselButton
        aria-label={previousString}
        direction={isRtl ? "right" : "left"}
        size="large"
        onClick={() => swiper?.slidePrev()}
      />
      <SwiperCarousel
        className={styles.carousel}
        itemTypeMessage="projects"
        carouselItems={slides}
        onSwiper={setSwiper}
        breakpoints={{
          // When window width is >= 0px.
          0: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesPerGroup: 2
          },
          // When window width is >= 768px.
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 3
          }
        }}
        slideClassName={styles.slide}
      />
      <CarouselButton
        aria-label={nextString}
        direction={isRtl ? "left" : "right"}
        size="large"
        onClick={() =>
          (swiper?.activeIndex ?? 0) < slides.length - 2
            ? swiper?.slideNext()
            : swiper?.slideTo(1)
        }
      />
    </div>
  );
};
export default ProjectsCarousel;
